/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable complexity */
/* eslint-disable no-await-in-loop */
/* eslint-disable prefer-const */

import DispatchersMixin from '@/mixins/dispatchers';
import EntitiesDocumentsDownloader from '@/use/EntitiesDocumentsDownloader';
import permissionUser from '@/inheritance/permission-user';
import VTableBody from '@/components/table-body/index.vue';
import VTableFilters from '@/components/table-filters/index.vue';
import VTableHeader from '@/components/table-header/index.vue';
import VTableSettings from '@/components/table-settings/index.vue';

import TableExportIcon from './table-export-icon/index.vue';

import { setTableWidths } from '@/use/table.space';

export default {
  name: 'VTable',
  mixins: [DispatchersMixin],
  extends: permissionUser,

  components: {
    VTableBody,
    VTableHeader,
    VTableSettings,
    VTableFilters,
    TableExportIcon
  },
  /**
   * @override
   */
  data() {
    return {
      settingsEnabled: false,
      filtersEnabled: false,
      cols: [],
      widths: {},
      updateKey: 0,
      search: this.searchStored && this.searchStored.length ? JSON.parse(this.searchStored).join(' ') : '',
      limit: 10,
      page: 0,
      selectAll: false,
      heightCalculated: 0,
      selectedRows: [],
      newViewTitle: '',
      editViewFlag: false,
      selectedView: null,
      timeOutSearch: false,
      timeOutSearchTime: 1000,
      waitSearch: false,
      cleaningSearch: false,
      localStorageWidthsData: null,
      operationsDate: this.$moment(new Date()).format('YYYY-MM-DD'),
      horaLimiteEnvioRD: this.$store.getters['configVarsStore/getConfigVar']('LIMIT_HOUR_RD_SEND') || '14',
      skipDateOperationsDate: false,
      isDownloadingDocuments: false,
      loading: false
    };
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    metadata: {
      type: Object,
      required: true
    },
    columns: {
      type: Array,
      required: true
    },
    self: {
      type: Array,
      required: true
    },
    section: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isSearching: {
      type: Boolean,
      default: false
    },
    reFilters: {
      type: Array,
      required: false
    },
    views: {
      type: Array,
      required: false
    },
    searchStored: {
      type: Array | String,
      required: false
    }
  },
  watch: {
    search(val) {
      clearTimeout(this.timeOutSearch);
      let time = this.timeOutSearchTime;
      if (this.cleaningSearch) {
        time = 0;
      }
      this.waitSearch = true;
      this.timeOutSearch = setTimeout(() => {
        this.cleaningSearch = false;
        const q = val.split(' ');
        this.selectedRows = [];
        this.selectAll = false;
        this.waitSearch = false;
        this.$emit('search', JSON.stringify(q));
      }, time);
    }
  },
  /**
   * Al crear la tabla calculamos los anchos de cada columna
   */
  created() {
    this.widths = setTableWidths(this.$route.name, this.columns);
  },
  /**
   * @override
   */
  mounted() {
    this.cols = this.columns.filter(x => {
      // Limpiamos columnas que empieces por '_' o contengan 'uuid'
      return x.name[0] !== '_' && !x.name.includes('uuid');
    });

    this.$root.$off('refreshWidthColumns');
    this.$root.$on('refreshWidthColumns', cols => {
      this.onWidthsChange(cols);
    });
    this.$root.$off('downloadExport');
    this.$root.$on('downloadExport', (cols, format) => this.$emit('downloadExport', cols, format));

    // emit lanzado cuando se ha exportado un CSV/XLXS
    this.$root.$off('deselectAllRows');
    this.$root.$on('deselectAllRows', () => {
      this.updateKey++;
      this.selectedRows = [];
      this.selectAll = false;
    });

    const jsTableTop = this.$refs.jsTableTop.clientHeight;
    this.heightCalculated = `${this.$refs.jstable.clientHeight - jsTableTop - 20}px`;
  },
  methods: {
    async handleDownloadDocuments(entities) {
      if (!this.isAllowedToExecuteBatchDownloads || this.isDownloadingDocuments) {
        return;
      }
      const sectionToEntityTypeMap = {
        accounts: 'account',
        interveners: 'intervener',
        operations: 'operation'
      };
      const sectionToUpdateMethodMap = {
        accounts: this.$accountsService.updateAccountInfo,
        interveners: this.$intervenersService.updateIntervenerInfo,
        operations: this.$operationsService.updateOperation
      };
      const entityType = sectionToEntityTypeMap[this.section];
      const updateMethod = sectionToUpdateMethodMap[this.section];
      const entitiesDocumentsDownloader = new EntitiesDocumentsDownloader(
        this,
        EntitiesDocumentsDownloader.MODE_TYPES.GROUPED,
        entityType
      );
      this.isDownloadingDocuments = true;
      try {
        const uuids = entities.map(entity => entity.uuid);
        this.$root.$emit('downloading', uuids);
        await entitiesDocumentsDownloader.download(entities);
        const updateDocsDownloadedFlagPromises = entities.map(entity =>
          updateMethod(entity.uuid, { has_docs_been_downloaded: true })
        );
        await Promise.all(updateDocsDownloadedFlagPromises);
        this.$root.$emit('updateItems');
      } catch (error) {
        console.error(error);
      } finally {
        this.isDownloadingDocuments = false;
      }
    },
    onWidthsChange(w) {
      this.widths = w;
    },

    /**
     * @override
     */
    handleScroll(el) {
      const floor = Math.floor(el.target.scrollTop + el.srcElement.clientHeight);
      const ceil = Math.ceil(el.target.scrollTop + el.srcElement.clientHeight);
      const bottomOfWindow = [ceil, floor].includes(el.srcElement.scrollHeight);
      if (bottomOfWindow) {
        this.$emit('infiniteScroll');
      }
    },

    /**
     * @override
     */
    colsChange(e) {
      this.$emit('colsChange', e);
    },
    /**
     * @override
     */
    applyFilters(e) {
      this.selectedRows = [];
      this.selectAll = false;
      this.$emit('filter', e);
    },
    /**
     * Mostramos el modal para editar una view
     * @param {Object} view a editar
     */
    handleEditView(view) {
      this.selectedView = view;
      this.editViewFlag = true;
      this.newViewTitle = view.title;
      this.showViewModal();
    },
    /**
     * Mostramos el modal para eliminar una view
     * @param {String} view a eliminar
     */
    handleDeleteView(view) {
      this.selectedView = view;
      this.newViewTitle = view.title;
      this.showDeleteViewModal();
    },
    /**
     * Editamos el título de la vista seleccionada
     */
    editView() {
      if (this.editView) {
        this.$bvModal.hide('modalView');
        this.$emit('updateView', { view: this.selectedView, title: this.newViewTitle });
        this.editViewFlag = false;
        this.selectedView = null;
      } else {
        this.$emit('saveView', this.newViewTitle);
      }
    },
    /**
     * Borramos la vista seleccionada
     * @param {Object} view Cargamos la información de la vista
     */
    loadView(view) {
      this.$emit('loadView', view);
    },
    /**
     * Detectamos cambios en el orden de las columnas
     * @param {Object} evt Cargamos la información de las columnas
     */
    input(evt) {
      this.cols = evt;
      this.$emit('colsChange', evt);
    },
    /**
     * Borramos la vista seleccionada
     * @param {Object} view Id de la vista a eliminar
     */
    deleteView() {
      this.$bvModal.hide('modalDeleteView');
      this.$emit('deleteView', this.selectedView);
      this.editViewFlag = false;
      this.selectedView = null;
    },
    /**
     * Guardamos la vista actual
     */
    saveView() {
      this.$bvModal.hide('modalView');
      this.$emit('saveView', { title: this.newViewTitle, widths: this.widths });
      // this.$emit('saveView', this.newViewTitle);
    },

    deselectView() {
      this.editViewFlag = false;
      this.selectedView = null;
      this.$emit('deselectView');
    },

    /**
     * Seleccionamos todos los items
     */
    selectAllItems() {
      if (this.selectAll) {
        this.selectedRows = [];
      } else {
        this.selectedRows = this.items.map(item => item);
      }
      this.selectAll = !this.selectAll;
    },
    /**
     * @override
     */
    // downloadFiles(format) {
    //     this.$emit('downloadExport', this.colsVisible, this.selectedRows, format);
    // },
    /**
     * Borramos los items seleccionados
     */
    deleteSelected() {
      if (
        this.actionObject(this.section.toUpperCase(), 'remove') &&
        this.selectedRows.length &&
        this.selectedRows.length <= 5
      ) {
        const sectionService = this.getSectionService();
        const promises = this.selectedRows.map(row => this[sectionService].deleteByUUIId(row.uuid));

        Promise.allSettled(promises).then(responses => {
          const successfulDeletionsResponses = responses.filter(
            res => res.status === 'fulfilled' && res.value.data !== undefined
          );
          const successfulDeletionsUuids = successfulDeletionsResponses.map(res => {
            const item = this.section.slice(0, -1);
            let key = 'uuid';
            Object.keys(res.value.data[item] || res.value.data).some(k => {
              if (key.includes('uuid')) {
                key = k.includes('uuid') ? k : key; // no todas las respuestas llevan 'uuid' hay algunas como 'uuid_intervener'
                return key;
              } else {
                return null;
              }
            });
            return res.value.data[item] ? res.value.data[item][key] : res.value.data[key];
          });

          this.hideDeletionModal();

          if (successfulDeletionsUuids.length) {
            const failedDeletionsUuids = this.selectedRows.filter(
              itemUuid => !successfulDeletionsUuids.includes(itemUuid)
            );

            const failedDeletionsItems = this.items.filter(item => failedDeletionsUuids.includes(item.uuid));

            this.handleDeletedItems(successfulDeletionsUuids, failedDeletionsUuids);

            if (failedDeletionsItems.length) {
              const failedList = failedDeletionsItems.reduce(
                (accumulator, currentValue) => `${accumulator} ${currentValue._self_name}, `,
                ''
              );
              // eliminar coma y espacio final
              failedList.replace(/,\s*$/, '');
              this.$toast.error(`400`, `Error al borrar los siguientes registros: ${failedList}`);
            } else {
              this.$toast.success(`200`, `Todos los registros han sido borrados con éxito.`);
            }
          } else {
            this.$toast.error(`400`, `No se ha podido borrar ningún registro.`);
          }
        });
      }
    },
    /**
     * Después de borrar actualizamos el listado y los items seleccionados
     * @param {Array} successfulDeletions uuids de los items borrados
     * @param {Array} failedDeletionsUuids uuids de los items que no se han podido borrar
     */
    handleDeletedItems(successfulDeletions, failedDeletionsUuids) {
      this.$emit('deleted-items', successfulDeletions);
      this.selectedRows = failedDeletionsUuids;
      this.$refs.tableBody.setSelectedItems(failedDeletionsUuids);
    },
    /**
     * Abrimos el formulario de creación
     */
    async openCreationForm() {
      let query;
      if (this.$route.name === 'accounts') {
        const defaultConfigUuid = process.env.VUE_APP_ENTITY_UUID || "5271fc2d-f79c-4e25-bf50-31625b337c01";
        const id = localStorage.getItem("OBENST") || defaultConfigUuid;
        const res = await this.$usersService.getPublicConfiguration(id);
        const configFromDB = res.data.configuration.initial_configuration;
        const onboardingUrl = configFromDB.onboarding_path;
        onboardingUrl ? window.open(onboardingUrl) : null;
        return;
      }
      const item = {
        active: true,
        name: this.getCreationFormName(),
        route: {
          name: `${this.$route.name}_add`,
          params: {},
          query,
          force: true
        }
      };
      this.setMenuTab(item);
    },
    /**
     * Devuelve el nombre de la vista de detalles para la sección actual
     * @return {String} Nombre de la vista de detalles
     */
    getCreationFormName() {
      switch (this.section) {
        case 'issues':
          return 'Nueva incidencia';

        case 'accounts':
          return 'Nueva cuenta';

        case 'groups':
          return 'Nuevo grupo';

        case 'interveners':
          return 'Nuevo interviniente';

        case 'operations':
          return 'Nueva operación';

        case 'users':
          return 'Nuevo usuario';

        case 'permission_sets':
          return 'Nuevo permission set';

        default:
          return null;
      }
    },
    /**
     * Mostramos el modal de guardado de vistas
     */
    showViewModal() {
      this.$bvModal.show('modalView');
    },
    /**
     * Ocultamos el modal de guardado de vistas
     */
    hideViewModal() {
      this.$bvModal.hide('modalView');
    },
    /**
     * Mostramos el modal del eliminado de vistas
     */
    showDeleteViewModal() {
      this.$bvModal.show('modalDeleteView');
    },
    /**
     * Ocultamos el modal del eliminado de vistas
     */
    hideDeleteViewModal() {
      this.$bvModal.hide('modalDeleteView');
    },
    /**
     * Mostramos el modal de borrado
     */
    showDeletionModal() {
      this.$bvModal.show('modalRemove');
    },
    /**
     * Ocultamos el modal de borrado
     */
    hideDeletionModal() {
      this.$bvModal.hide('modalRemove');
    },
    /**
     * Mostramos el modal de validar
     */
    showValidateModal() {
      this.$bvModal.show('modalValidate');
    },
    /**
     * Ocultamos el modal de validar
     */
    hideValidateModal() {
      this.$bvModal.hide('modalValidate');
    },
    /**
     * Mostramos el modal de enviar a RD
     */
    showRDSendModal() {
      this.$bvModal.show('modalRDSend');
    },
    /**
     * Ocultamos el modal de enviar a RD
     */
    hideRDSendModal() {
      this.$bvModal.hide('modalRDSend');
    },
    /**
     * Mostramos el modal de enviar a RD
     */
    showCancelModal() {
      this.$bvModal.show('modalCancel');
    },
    /**
     * Ocultamos el modal de enviar a RD
     */
    hideCancelModal() {
      this.$bvModal.hide('modalCancel');
    },
    showDeleteModal() {
      this.$bvModal.show('modalDelete');
    },
    hideDeleteModal() {
      this.$bvModal.hide('modalDelete');
    },
    /**
     * Devuelve el servicio de la sección actual
     * @return {String} nombre del servicio
     */
    getSectionService() {
      switch (this.section) {
        case 'issues':
          return '$issuesService';

        case 'accounts':
          return '$accountsService';

        case 'groups':
          return '$groupsService';

        case 'interveners':
          return '$intervenersService';

        case 'operations':
          return '$operationsService';

        case 'users':
          return '$usersService';

        case 'permission_sets':
          return '$permissionService';

        default:
          return null;
      }
    },

    /**
     * Cleans search
     */
    cleanSearch() {
      this.cleaningSearch = true;
      this.search = '';
    },

    /**
     * Validate selected items
     */
    validateSelected() {
      this.loading = true
      let promises = [];

      switch (this.section) {
        case 'interveners':
          promises = this.selectedRows.map(row =>
            this.$intervenersService.changeIntervenerStatus(row.uuid, { status: 'VALIDADO' })
          );
          break;
        case 'accounts':
          promises = this.selectedRows.map(row =>
            this.$accountsService.changeAccountStatus(row.uuid, { status: 'VALIDADO' })
          );
          break;
        case 'operations':
          promises = this.selectedRows.map(row =>
            this.$operationsService.changeOperationStatus(row.uuid, { status: 'VALIDATED' })
          );
          break;
        default:
          break;
      }

      this.hideValidateModal();
      
      if (promises.length) {
        Promise.all(promises)
          .then(() => this.proccessSelected(promises))
          .finally(() => this.loading = false);
      } else {
        this.loading = false;
      }
    },

    /**
     * Send to RD selected items
     */
    async sendRDSelected() {
      let promises = [];

      switch (this.section) {
        case 'interveners':
          promises = this.selectedRows.map(row =>
            this.$intervenersService.changeIntervenerStatus(row.uuid, {
              status: 'ENVIADO',
              sendToRD: true
            })
          );
          break;
        case 'accounts':
          promises = this.selectedRows.map(row =>
            this.$accountsService.changeAccountStatus(row.uuid, {
              status: 'ENVIADO',
              sendToRD: true
            })
          );
          break;
        case 'operations':
          if (
            this.operationsDate === this.$moment(new Date()).format('YYYY-MM-DD') &&
            this.$moment() > this.$moment(this.horaLimiteEnvioRD, 'h') &&
            !this.skipDateOperationsDate
          ) {
            this.hideRDSendModal();
            this.$bvModal.show('modalSendOperationToRDLate');
          } else {
            this.skipDateOperationsDate = false;
            const PERIODIC_OPERATION_TYPES = [
              'SOLICITUD_SUSCRIPCION_PERIODICA',
              'SOLICITUD_REEMBOLSO_PERIODICO',
              'SOLICITUD_APORTACION_PERIODICA',
              'SUSCRIPCION_PERIODICA',
              'REEMBOLSO_PERIODICO',
              'APORTACION_PERIODICA'
            ];
            for (const row of this.selectedRows) {
              // Las operaciones periódicas NUNCA se envían a RD
              if (PERIODIC_OPERATION_TYPES.includes(row.key_operation_type)) {
                continue;
              }

              // operation-status necesita tener operation_date para poder mandar a RD
              await this.$operationsService.updateOperation(row.uuid, {
                operation_date: this.$moment(this.operationsDate).format('YYYY-MM-DD')
              });

              promises.push(
                this.$operationsService.changeOperationStatus(row.uuid, {
                  status: 'RD_SENT',
                  sendToRD: true,
                  operation_date: this.$moment(this.operationsDate).format('YYYY-MM-DD')
                })
              );
            }
          }
          break;
        default:
          break;
      }
      this.hideRDSendModal();
      if (promises.length) {
        this.proccessSelected(promises);
      }
    },

    /**
     * cancel selected items
     */
    cancelSelected() {
      let promises = [];

      switch (this.section) {
        case 'interveners':
          break;
        case 'accounts':
          promises = this.selectedRows.map(row =>
            this.$accountsService.changeAccountStatus(row.uuid, {
              status: 'ENVIADO',
              sendToRD: true
            })
          );
          break;
        case 'operations':
          promises = this.selectedRows.map(row =>
            this.$operationsService.changeOperationStatus(row.uuid, {
              status: 'CANCELLED'
            })
          );
          break;
        default:
          break;
      }
      this.hideCancelModal();
      if (promises.length) {
        this.proccessSelected(promises);
      }
    },

    /** Procesa las promesas de validateSelected y sendRDSelected
     * @param {Object} promises promesas a procesar
     */
    proccessSelected(promises) {
      Promise.allSettled(promises).then(responses => {
        const successfulResponses = responses.filter(res => res.status === 'fulfilled' && res.value.data !== undefined);

        const successfulArray = [];
        const errorArray = [];
        const operationWithNewIssue = successfulArray.find(response => !!response.data.operationIssueMessage);
        this.selectedRows.forEach(item => {
          let isSuccesful = false;
          for (let index = 0; index < successfulResponses.length; index++) {
            const successfulResponse = successfulResponses[index];
            if (
              this.section === 'interveners' &&
              successfulResponse.value.data.intervener_historical.uuid_intervener === item.uuid
            ) {
              isSuccesful = true;
            } else if (this.section === 'accounts' && successfulResponse.value.data.account.uuid === item.uuid) {
              isSuccesful = true;
            } else if (this.section === 'operations' && successfulResponse.value.data.operation.uuid === item.uuid) {
              isSuccesful = true;
            }
          }
          if (isSuccesful) {
            successfulArray.push(item);
          } else {
            errorArray.push(item);
          }
        });

        if (errorArray.length) {
          let failedList = errorArray.reduce(
            (accumulator, currentValue) => `${accumulator} ${currentValue._self_name}, `,
            ''
          );
          failedList = failedList.replace(/,\s*$/, '');
          this.$toast.error(`Error`, `Error al procesar los siguientes registros: ${failedList}`, 20000);
        }
        if (successfulArray.length) {
          let successList = successfulArray.reduce(
            (accumulator, currentValue) => `${accumulator} ${currentValue._self_name}, `,
            ''
          );
          successList = successList.replace(/,\s*$/, '');
          this.$toast.success(`Ok`, `Procesados correctamente los siguientes registros: ${successList}`, 20000);
        }
        if (operationWithNewIssue) {
          this.$toast.success(`Nuevo caso`, operationWithNewIssue.data.operationIssueMessage, 20000);
        }
        this.selectedRows = [];
        this.selectAll = false;
        this.$emit('loadItems');
      });
    },

    /**
     * Cancela envio a RD (cierre de modal)
     */
    cancelSendOperationToRD() {
      this.$bvModal.hide('modalSendOperationToRDLate');
    },
    /**
     * Confirma envio a RD (cierre de modal y sendOperationToRD)
     */
    confirmSendOperationToRD() {
      this.skipDateOperationsDate = true;
      this.$bvModal.hide('modalSendOperationToRDLate');
      this.sendRDSelected();
    },

    /**
     * Comprobamos si la operación puede ser enviada a RD
     * @param {Object} item - item seleccionado del listado
     * @return {Boolean} Devuelve si se puede mostrar la opción de enviar a RD seleccionados
     */
    operationEnableSendToRD(item) {
      return (
        item.operation_status === 'VALIDATED' &&
        // COMENTADA la comprobación de la conciliación: YURI-2386
        // (
        //     (item.key_operation_type !== 'APORTACION' && item.key_operation_type !== 'SUSCRIPCION') ||
        //     item.reconciliation_status === 'CONCILIADO'
        // ) &&
        (item.account_status === 'ENVIADO' || item.account_status === 'FINALIZED')
      );
    }
  },
  computed: {
    isAllowedToExecuteBatchDownloads() {
      return ['accounts', 'interveners', 'operations'].includes(this.section);
    },
    /**
     * Devuelve las columnas que tienen el check 'activo' a true
     * @return {Array} Array de columnas visibles
     */
    colsVisible() {
      return this.cols.filter(x => x.active === true);
    },

    /**
     * Comprobamos si el listado debe de mostrar la opción de borrar las filas seleccionadas
     * @return {Boolean} Devuelve si se puede mostrar la opción de borrar seleccionados
     */
    enableRemoveSelected() {
      const canBeDeleted = this.selectedRows.every(item => {
        return item.operation_status === 'ENVIADO' || item.operation_status === 'FINALIZED';
      });
      return this.selectedRows.length && canBeDeleted;
    },

    /**
     * Comprobamos si el listado debe de mostrar la opción de validar las filas seleccionadas
     * @return {Boolean} Devuelve si se puede mostrar la opción de validar seleccionados
     */
    enableValidate() {
      // Se muestra si todos los elementos seleccionados cumplen las condiciones
      const canBeValidated = this.selectedRows.every(item => {
        const status = item.status || item.intervener_status || item.operation_status || '';
        const isRegistered = status.includes('REGISTERED');
        const isNotRegisteredPostal = status !== 'REGISTERED_POSTAL';
        const isSigned = status === 'SIGNED';
        return (
          (item.can_be_validated && ((isRegistered && isNotRegisteredPostal) || isSigned)) ||
          (item.has_docs_been_downloaded && (isRegistered || isSigned))
        );
      });
      return this.selectedRows.length && canBeValidated;
    },

    /**
     * Comprobamos si el listado debe de mostrar la opción de enviar a RD las filas seleccionadas
     * @return {Boolean} Devuelve si se puede mostrar la opción de enviar a RD seleccionados
     */
    enableSendToRD() {
      // Se muestra si todos los elementos seleccionados están validados
      const canBeSended = this.selectedRows.every(item => {
        return (
          item.intervener_status === 'VALIDADO' ||
          item.status === 'VALIDADO' ||
          this.operationEnableSendToRD(item)
        );
      });
      return this.selectedRows.length && canBeSended;
    },

    /**
     * Comprobamos si el listado debe de mostrar la opción de cancelar las filas seleccionadas
     * @return {Boolean} Devuelve si se puede mostrar la opción de cancelar seleccionados
     */
    enableCancel() {
      const canBeCanceled = this.selectedRows.every(item => {
        return (
          item.operation_status &&
          (item.operation_status === 'SIGNED' ||
            item.operation_status.includes('REGISTERED') ||
            item.operation_status === 'VALIDATED')
        );
      });
      return this.selectedRows.length && canBeCanceled;
    },

    /**
     * Comprobamos si en la ruta actual está habilitada la opción de crear item o no
     * @return {Boolean} Devuelve si se puede o no crear un nuevo item
     */
    enableAddItem() {
      const urls = [
        'permission_set',
        'issues',
        'users',
        'operations',
        'groups',
        // 'interveners',
        'accounts'
      ];
      return urls.indexOf(this.$route.name) >= 0 ? true : false;
    },

    activeTableView() {
      const viewLoaded = JSON.parse(localStorage.getItem(`table_view_selected_${this.$route.name}`));
      return viewLoaded || null;
    }
  }
};
